module.exports = __webpack_public_path__ + "static/img/purchase2.eb1e7cc6.png";